import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-5 mb-9" }, null, -1)
const _hoisted_4 = { class: "row mb-7" }
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-semobold mb-2 createAccountTitle" }, " Sales Type ", -1)
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { class: "fs-6 fw-semobold mb-2 createAccountTitle" }
const _hoisted_9 = {
  key: 0,
  class: "ms-3",
  style: {"color":"#900000"}
}
const _hoisted_10 = {
  key: 1,
  class: "ms-3",
  style: {"color":"#900000"}
}
const _hoisted_11 = { class: "d-flex align-items-center mt-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "ms-1 me-7",
  for: "daily"
}, "Daily", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "ms-1 me-7",
  for: "month"
}, "Monthly", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "ms-1 me-7",
  for: "pause"
}, "Pause", -1)
const _hoisted_15 = { class: "row mb-5" }
const _hoisted_16 = { class: "col-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-semobold mb-2 createAccountTitle" }, " Sales Account Uid ", -1)
const _hoisted_18 = { class: "col-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-semobold mb-2 createAccountTitle" }, " Target Account Uid ", -1)
const _hoisted_20 = { class: "row mb-9" }
const _hoisted_21 = { class: "col-6" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-semobold mb-2 createAccountTitle" }, " Rebate ", -1)
const _hoisted_23 = { class: "col-6" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-semobold mb-2 createAccountTitle" }, " Alpha Rebate ", -1)
const _hoisted_25 = { class: "col-6" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-semobold mb-2 createAccountTitle" }, " Pro Rebate ", -1)
const _hoisted_27 = { class: "row mb-9" }
const _hoisted_28 = { class: "col-6" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-semobold mb-2 createAccountTitle" }, " Exclude Account ", -1)
const _hoisted_30 = { class: "col-6" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-semobold mb-2 createAccountTitle" }, " Exclude Symbol ", -1)
const _hoisted_32 = { class: "row mb-5" }
const _hoisted_33 = { class: "col-12" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-semobold mb-2 createAccountTitle" }, " Note ", -1)
const _hoisted_35 = {
  key: 0,
  style: {"border":"2px solid #e6a23c","border-radius":"10px","padding":"10px"}
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex align-items-center mb-4",
  style: {"font-size":"18px"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa-solid fa-triangle-exclamation fa-xl me-3",
    style: {"color":"#900000"}
  }),
  /*#__PURE__*/_createElementVNode("div", null, " Please note that the updated schema will require re-approval to work. ")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex align-items-center mb-2",
  style: {"font-size":"18px"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa-solid fa-triangle-exclamation fa-xl me-3",
    style: {"color":"#900000"}
  }),
  /*#__PURE__*/_createElementVNode("div", null, "请注意，更新后的反佣規則需要重新批准才能生效。")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex align-items-center",
  style: {"font-size":"18px"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa-solid fa-triangle-exclamation fa-xl me-3",
    style: {"color":"#900000"}
  }),
  /*#__PURE__*/_createElementVNode("div", null, " Xin lưu ý rằng các quy tắc phân phối hoa hồng được cập nhật cần phải được phê duyệt lại trước khi chúng có hiệu lực. ")
], -1)
const _hoisted_39 = [
  _hoisted_36,
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = { class: "mt-13 d-flex flex-row-reverse" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-light btn-danger btn-lg me-3 mb-9" }, " Cancel ", -1)

import { ref, nextTick } from "vue";
import RebateService from "../services/RebateService";
import SimpleForm from "@/components/SimpleForm.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { Field } from "vee-validate";
import { salesTypeOptions } from "@/core/types/SalesTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesRebateSchemaDetail',
  emits: ["refresh"],
  setup(__props, { expose: __expose, emit: emits }) {



const isLoading = ref(true);
const salesRebateSchemaDetailShowRef = ref<any>(null);
const schemaInfo = ref({} as any);

const show = async (_item: any) => {
  salesRebateSchemaDetailShowRef.value?.show();

  isLoading.value = true;
  schemaInfo.value = JSON.parse(JSON.stringify(_item));
  schemaInfo.value.excludeAccount = schemaInfo.value.excludeAccount.join(",");
  schemaInfo.value.excludeSymbol = schemaInfo.value.excludeSymbol.join(",");
  isLoading.value = false;
};

const update = async () => {
  try {
    await RebateService.putSalesRebateSchema(
      schemaInfo.value.id,
      schemaInfo.value
    );
    emits("refresh");
    salesRebateSchemaDetailShowRef.value?.hide();
  } catch (e) {
    MsgPrompt.error(e);
  }
};

const approve = async () => {
  try {
    await RebateService.putSalesRebateSchemaStatus(schemaInfo.value.id);
    emits("refresh");
    salesRebateSchemaDetailShowRef.value?.hide();
  } catch (e) {
    MsgPrompt.error(e);
  }
};

__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "salesRebateSchemaDetailShowRef",
    ref: salesRebateSchemaDetailShowRef,
    title: 'Schema Detail',
    "is-loading": isLoading.value,
    width: 800,
    "disable-footer": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_LoadingRing)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_el_select, {
                    modelValue: schemaInfo.value.salesType,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((schemaInfo.value.salesType) = $event)),
                    placeholder: _ctx.$t('fields.status')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(salesTypeOptions), (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, [
                    _createTextVNode(" Schedule "),
                    (schemaInfo.value.status == -1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "( All records will be updated after approve !! )"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, "( All \"" + _toDisplayString(schemaInfo.value.rebateAccountUid) + "\" records will be updated !! )", 1))
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      id: "daily",
                      type: "radio",
                      value: "0",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((schemaInfo.value.schedule) = $event))
                    }, null, 512), [
                      [_vModelRadio, schemaInfo.value.schedule]
                    ]),
                    _hoisted_12,
                    _withDirectives(_createElementVNode("input", {
                      id: "month",
                      type: "radio",
                      value: "3",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((schemaInfo.value.schedule) = $event))
                    }, null, 512), [
                      [_vModelRadio, schemaInfo.value.schedule]
                    ]),
                    _hoisted_13,
                    _withDirectives(_createElementVNode("input", {
                      id: "pause",
                      type: "radio",
                      value: "1",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((schemaInfo.value.schedule) = $event))
                    }, null, 512), [
                      [_vModelRadio, schemaInfo.value.schedule]
                    ]),
                    _hoisted_14
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_unref(Field), {
                    modelValue: schemaInfo.value.salesAccountUid,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((schemaInfo.value.salesAccountUid) = $event)),
                    class: "form-control form-control-lg form-control-solid",
                    type: "number",
                    name: "symbolRule",
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: schemaInfo.value.salesAccountUid,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((schemaInfo.value.salesAccountUid) = $event)),
                        size: "large",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_unref(Field), {
                    modelValue: schemaInfo.value.rebateAccountUid,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((schemaInfo.value.rebateAccountUid) = $event)),
                    class: "form-control form-control-lg form-control-solid",
                    type: "number",
                    name: "symbolRule",
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: schemaInfo.value.rebateAccountUid,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((schemaInfo.value.rebateAccountUid) = $event)),
                        size: "large",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(_unref(Field), {
                    modelValue: schemaInfo.value.rebate,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((schemaInfo.value.rebate) = $event)),
                    class: "form-control form-control-lg form-control-solid",
                    type: "number",
                    name: "symbolRule",
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: schemaInfo.value.rebate,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((schemaInfo.value.rebate) = $event)),
                        size: "large"
                      }, {
                        append: _withCtx(() => [
                          _createTextVNode("/100")
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createVNode(_unref(Field), {
                    modelValue: schemaInfo.value.alphaRebate,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((schemaInfo.value.alphaRebate) = $event)),
                    class: "form-control form-control-lg form-control-solid",
                    type: "number",
                    name: "symbolRule",
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: schemaInfo.value.alphaRebate,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((schemaInfo.value.alphaRebate) = $event)),
                        size: "large"
                      }, {
                        append: _withCtx(() => [
                          _createTextVNode("/100")
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createVNode(_unref(Field), {
                    modelValue: schemaInfo.value.proRebate,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((schemaInfo.value.proRebate) = $event)),
                    class: "form-control form-control-lg form-control-solid",
                    type: "number",
                    name: "symbolRule",
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: schemaInfo.value.proRebate,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((schemaInfo.value.proRebate) = $event)),
                        size: "large"
                      }, {
                        append: _withCtx(() => [
                          _createTextVNode("/100")
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createVNode(_unref(Field), {
                    modelValue: schemaInfo.value.excludeAccount,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((schemaInfo.value.excludeAccount) = $event)),
                    class: "form-control form-control-lg form-control-solid",
                    name: "symbolRule",
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: schemaInfo.value.excludeAccount,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((schemaInfo.value.excludeAccount) = $event)),
                        size: "large",
                        rows: 5,
                        type: "textarea"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createVNode(_unref(Field), {
                    modelValue: schemaInfo.value.excludeSymbol,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((schemaInfo.value.excludeSymbol) = $event)),
                    class: "form-control form-control-lg form-control-solid",
                    name: "symbolRule",
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: schemaInfo.value.excludeSymbol,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((schemaInfo.value.excludeSymbol) = $event)),
                        size: "large",
                        type: "textarea",
                        rows: 5
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createVNode(_unref(Field), {
                    modelValue: schemaInfo.value.note,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((schemaInfo.value.note) = $event)),
                    class: "form-control form-control-lg form-control-solid",
                    name: "symbolRule",
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: schemaInfo.value.note,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((schemaInfo.value.note) = $event)),
                        size: "large",
                        rows: 5,
                        type: "textarea"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              (schemaInfo.value.status != -1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_39))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                (schemaInfo.value.status == -1 && _ctx.$can('SuperAdmin'))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-light btn-warning btn-lg me-3 mb-9",
                      onClick: approve
                    }, " Approve "))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn btn-light btn-success btn-lg me-3 mb-9",
                  onClick: update
                }, " Update ")
              ])
            ]))
      ])
    ]),
    _: 1
  }, 8, ["is-loading"]))
}
}

})